import { render } from "./SubCategories.vue?vue&type=template&id=6d2d8d36&scoped=true"
import script from "./SubCategories.vue?vue&type=script&lang=js"
export * from "./SubCategories.vue?vue&type=script&lang=js"

import "./SubCategories.vue?vue&type=style&index=0&id=6d2d8d36&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d2d8d36"]])

export default __exports__